import React, { useState } from 'react';
import { 
  Typography,
  Button,
  Paper,
  Box
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { ProcedureCodeGrid } from '../../grids/estimateGrids';
import { AddEditEstProcedureDialog } from '../../dialogs/estimateDialogs';

export const ProcedureCodesSection: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleAddProcedureCode = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8fafc' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Procedure Codes
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddProcedureCode}
          sx={{
            backgroundColor: '#162346',
            '&:hover': {
              backgroundColor: '#1a2a52',
            },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Add Procedure Code
        </Button>
      </Box>
      <ProcedureCodeGrid />
      
      <AddEditEstProcedureDialog
        open={dialogOpen}
        editingProcedure={null}
        onClose={handleCloseDialog}
      />
    </Paper>
  );
};